import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

// local dependencies
import { actionListWidget as ActionListWidgetView } from 'ui/views/widgets/actionListWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { ActionListWidgetService } from 'services/actionListWidget';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import queryString from 'query-string';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { ActionListWidget } from 'ui/containers/ActionListWidget';
 *
 * // render
 * <ActionListWidget propName='propValue'/>
 */
export class _ActionListWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        
        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // bind methods
        this.handleActionClick = this.handleActionClick.bind( this );

        // create service instance
        this.actionListWidgetService = new ActionListWidgetService();
        
        // start data fetch
        this.fetchComponentData();
    }

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( '_ActionListWidget.fetchComponentData()' );

        // cancel ongoing request
        this.actionListWidgetService.cancel();

        // fetch component data
        const { status, data } = await this.actionListWidgetService.fetchComponentData(  {
            url: this.props.widget.url,
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
            
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /**
     * @desc Action handler for column action and group action.
     */
    handleActionClick( { type = 'column', /*value = {},*/ item = {} } = {} ) {
        log.debug( '_ActionListWidget.handleActionClick()' ); // @TODO: remove

        if( 'column' === type ) {
            this.props.history.push( { pathname: DASHBOARD_SUB_ROUTES.ACTION_DETAIL, search: queryString.stringify( {
                actionId: item.id,
            }  ) } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.actionListWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <ActionListWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                onActionClick={ this.handleActionClick }/>
        );
    }
}

// set display name
_ActionListWidget.displayName = '_ActionListWidget';

// set default props
_ActionListWidget.defaultProps = {
    widget: {}, // widget configuration
};

// prop types
_ActionListWidget.propTypes = {};

export const ActionListWidget = withRouter( _ActionListWidget );
